import React, { useEffect, useRef, useState } from "react";
import "./Hero.css";

import img2 from "../Assets/Frontend_Assets/ss1.jpeg";
import img1 from "../Assets/Frontend_Assets/ss2.jpeg";
import img5 from "../Assets/Frontend_Assets/ss3.jpeg";
import img4 from "../Assets/Frontend_Assets/ss4.jpeg";
import img3 from "../Assets/Frontend_Assets/ss5.jpeg";

const images = [img1, img2, img3, img4, img5]; // max 5

const Hero = () => {
  const [current, setCurrent] = useState(0);
  const touchStartX = useRef(0);

  /* AUTO SLIDE */
  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 5000);
    return () => clearInterval(interval);
  }, [current]);

  const nextSlide = () => {
    setCurrent((prev) => (prev + 1) % images.length);
  };

  const prevSlide = () => {
    setCurrent((prev) => (prev - 1 + images.length) % images.length);
  };

  /* MOBILE SWIPE */
  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = (e) => {
    const diff = touchStartX.current - e.changedTouches[0].clientX;
    if (diff > 50) nextSlide();
    if (diff < -50) prevSlide();
  };

  return (
    <div
      className="hero-slider"
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
    >
      {images.map((img, index) => (
        <div
          key={index}
          className={`slide ${
            index === current ? "active fade-slide" : ""
          }`}
        >
          <img src={img} alt={`slide-${index}`} />
        </div>
      ))}

      {/* ARROWS */}
      <button className="nav-btn prev" onClick={prevSlide}>
        ‹
      </button>
      <button className="nav-btn next" onClick={nextSlide}>
        ›
      </button>

      {/* DOTS */}
      <div className="slider-dots">
        {images.map((_, i) => (
          <span
            key={i}
            className={current === i ? "active" : ""}
            onClick={() => setCurrent(i)}
          />
        ))}
      </div>
    </div>
  );
};

export default Hero;
